<p-toast
  position="top-right"
  [breakpoints]="{ '1024px': { right: '0' } }"></p-toast>
<router-outlet></router-outlet>
